import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "../Image";
import style from "./style.module.scss";
export default function ChartTooltipAction(props) {
    const lightTheme = document.body.classList.contains("theme-light");
    const icon = lightTheme ? `light-theme/${props.icon}` : `dark-theme/${props.icon}`;
    return (_jsxs("div", { className: style["tooltip-action"], children: [_jsx(Image, { path: `img/icons/${icon}.png`, width: 16 }), props.children] }));
}
